<main class="main text-neutral-40" [ngClass]="appDisplay.display()">
  <router-outlet></router-outlet>
</main>
